export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";